import { render, staticRenderFns } from "./MaterialesResultFile.vue?vue&type=template&id=52e01f78&scoped=true"
import script from "./MaterialesResultFile.vue?vue&type=script&lang=js"
export * from "./MaterialesResultFile.vue?vue&type=script&lang=js"
import style0 from "./MaterialesResultFile.vue?vue&type=style&index=0&id=52e01f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e01f78",
  null
  
)

export default component.exports